import { IUserClient } from "@multiweb/clients/user";
import { IUser } from "@multiweb/types/contracts";
import { AsyncLock } from "Global/Base/Promises/AsyncLock";
import { CancellationToken } from "Global/Base/Promises/CancellationTokenSource";
import { ASServices } from "OW.Remoting/Basic/ServiceEndpoints";
import { getCancellationTokenAsRequestContext } from "../../../RequestContext";
import { BaseClient } from "../BaseClient";

interface ILoggedUserObjectInfoDTO {
    /** Hodnota ID na třídě CUzivatel */
    UserID: number;
    /** Hodnota GUID na třídě CUzivatel */
    UserGuid: string;
    /** Hodnota Uzivatelske_jmeno na třídě CUzivatel */
    UserName: string;
    /** Hodnota Osoba_bridge.Kod na třídě CUzivatel */
    PersonBridgeCode: string | null;
    /** Hodnota Osoba_bridge.Nazev na třídě CUzivatel */
    PersonBridgeName: string | null;
    /** Hodnota Osoba_bridge.eMail_adresa na třídě CUzivatel */
    PersonBridgeEmailAddress: string | null;
    /** Hodnota Osoba_bridge.Mobil na třídě CUzivatel */
    PersonBridgePhone: string | null;
    /** Hodnota Osoba_bridge.Rozliseni na třídě CUzivatel */
    PersonBridgeDistinction: string | null;
}

/**
 * Základní informace o uživateli se načítají jen jednou a pak už jsou cachovaná
 * @internal
 */
export class UserClient extends BaseClient implements IUserClient {
    private _currentUserInfo: IUser | null = null;
    private _loadingLock = new AsyncLock();

    public async getCurrentUserInfo(cancellationToken: CancellationToken = CancellationToken.none): Promise<IUser> {
        const releaser = await this._loadingLock.lock();
        try {
            if (this._currentUserInfo == null) {
                this._currentUserInfo = await this._communicationManager.callGETRequest("LogedUserInfo", ASServices.owManager, undefined, undefined, getCancellationTokenAsRequestContext(cancellationToken)).then(this._transformResponse);
            }

            return this._currentUserInfo;
        } finally {
            releaser.release();
        }
    }

    private _transformResponse(response: ILoggedUserObjectInfoDTO): IUser {
        return {
            id: response.UserID,
            guid: response.UserGuid,
            userName: response.UserName,
            fullName: response.PersonBridgeName,
            email: response.PersonBridgeEmailAddress,
        };
    }
}
